// extracted by mini-css-extract-plugin
export default {"link":"navigation_link__-abeQ","white":"navigation_white__FkZ2x","black":"navigation_black__mTlhN","flexGrow":"navigation_flexGrow__G6BV0","theme":"navigation_theme__dxJNL"};